var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideIcon4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "guide-icon-4_svg__a",
    d: "M0 40h44.138V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.207 14.138c0 7.046-5.713 12.759-12.759 12.759S.69 21.184.69 14.138 6.402 1.38 13.448 1.38c7.046 0 12.759 5.712 12.759 12.758",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.346 9.655c1.894 0 3.344 1.442 3.344 3.222v20.916H4.138V12.877c0-1.84 1.143-3.222 3.037-3.222h30.171z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.828 33.103H40V12.877c0-1.42-1.166-2.532-2.654-2.532H7.176c-1.427 0-2.348.993-2.348 2.532v20.226zm36.551 1.38H3.45V12.877c0-2.303 1.532-3.911 3.726-3.911h30.171c2.262 0 4.033 1.717 4.033 3.91v21.607z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.448 33.793H.69v.684c0 2.414 1.956 4.834 4.37 4.834h34.018c2.414 0 4.37-2.42 4.37-4.834v-.684z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38 34.483c.003 1.954 1.576 4.138 3.68 4.138h34.018c2.104 0 3.677-2.184 3.68-4.138H1.38zM39.077 40H5.06C2.365 40 0 37.42 0 34.477v-1.374h44.138v1.374c0 2.942-2.365 5.523-5.06 5.523z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "guide-icon-4_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#guide-icon-4_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#guide-icon-4_svg__b)",
    d: "M19.31 37.241h7.587v-1.379H19.31zm19.31-5.517h-1.379v-18.62H7.586v18.62h-1.38v-20h32.415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.448 2.759v11.07c0 1.123-.91 2.033-2.034 2.033H30.258l-4.199 5.333c-.405.514-1.231.228-1.231-.427v-4.906H23.46a2.087 2.087 0 01-2.08-2.08V2.759c0-1.143.925-2.07 2.068-2.07H41.38a2.07 2.07 0 012.07 2.07",
    fill: "#FEFEFE",
    mask: "url(#guide-icon-4_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.448 1.38a1.38 1.38 0 00-1.379 1.379V13.78c0 .768.624 1.391 1.391 1.391h2.057v5.596l4.406-5.596h11.491c.742 0 1.345-.602 1.345-1.343V2.759c0-.761-.619-1.38-1.38-1.38H23.45zm2.078 20.77a1.42 1.42 0 01-.46-.078 1.363 1.363 0 01-.928-1.304v-4.216h-.678a2.773 2.773 0 01-2.77-2.77V2.758A2.761 2.761 0 0123.448 0H41.38a2.761 2.761 0 012.759 2.759v11.07a2.726 2.726 0 01-2.724 2.723H30.592l-3.991 5.07a1.361 1.361 0 01-1.075.528z",
    fill: "#020303",
    mask: "url(#guide-icon-4_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#guide-icon-4_svg__b)",
    d: "M28.966 8.966h1.379v-1.38h-1.38zm2.758 0h1.38v-1.38h-1.38zm2.759 0h1.38v-1.38h-1.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.241 22.788c1.67 0 2.759-1.366 2.759-3.052v-1.018c0-1.686-1.088-3.052-2.759-3.052-1.67 0-2.758 1.366-2.758 3.052v1.018c0 1.686 1.088 3.052 2.758 3.052",
    fill: "#FEFEFE",
    mask: "url(#guide-icon-4_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.241 16.355c-1.421 0-2.069 1.224-2.069 2.363v1.018c0 1.138.648 2.362 2.07 2.362 1.42 0 2.068-1.224 2.068-2.362v-1.018c0-1.139-.647-2.363-2.069-2.363m0 7.123c-1.966 0-3.448-1.61-3.448-3.742v-1.018c0-2.133 1.482-3.742 3.448-3.742 1.967 0 3.449 1.609 3.449 3.742v1.018c0 2.133-1.482 3.742-3.449 3.742",
    fill: "#020303",
    mask: "url(#guide-icon-4_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.862 24.828c-3.274 0-4.828 1.043-4.828 4.138v2.758H21.38v-3.448h4.138c2.082 0 3.448-1.918 3.448-3.448H15.862z",
    fill: "#E74A10",
    mask: "url(#guide-icon-4_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.069 31.724h-1.38v-4.138h4.828c1.386 0 2.337-1.055 2.649-2.069H15.862c-3.055 0-4.138.903-4.138 3.449v2.758h-1.38v-2.758c0-4.28 2.95-4.828 5.518-4.828h13.793v.69c0 1.957-1.7 4.138-4.138 4.138H22.07v2.758z",
    fill: "#020303",
    mask: "url(#guide-icon-4_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#guide-icon-4_svg__b)",
    d: "M13.793 31.724h1.38v-3.448h-1.38z"
  }))));
}
export default SvgGuideIcon4;